export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11162.65653ee3.jpg";